"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeupdateWrapper = void 0;
class TimeupdateWrapper {
    constructor() {
        this.paused = false;
        this.handlersMap = new WeakMap();
        this.pauseUpdates = () => {
            this.paused = true;
        };
        this.resumeUpdates = () => {
            this.paused = false;
        };
    }
    wrap(el, callback) {
        var _a;
        if (this.handlersMap.get(el) == null) {
            this.handlersMap.set(el, []);
        }
        const handler = this.handle.bind(this, callback);
        (_a = this.handlersMap.get(el)) === null || _a === void 0 ? void 0 : _a.push(handler);
        el.addEventListener("timeupdate", handler);
        el.addEventListener("vdc:timeupdatePause", this.pauseUpdates);
        el.addEventListener("vdc:timeupdateResume", this.resumeUpdates);
    }
    handle(cb) {
        if (!this.paused) {
            cb();
        }
    }
    unwrap(el) {
        var _a;
        for (const handler of (_a = this.handlersMap.get(el)) !== null && _a !== void 0 ? _a : []) {
            el.removeEventListener("timeupdate", handler);
            el.removeEventListener("vdc:timeupdatePause", this.pauseUpdates);
            el.removeEventListener("vdc:timeupdateResume", this.resumeUpdates);
        }
    }
}
exports.TimeupdateWrapper = TimeupdateWrapper;
//# sourceMappingURL=timeupdate-wrapper.js.map